import styled from "styled-components/native";

import { Text1 } from "~/components/text";
import { colors } from "~/styles/theme";

export const Text = styled(Text1)`
  align-self: flex-end;
  color: ${({ theme }) => theme.colors.gray400};
`;
